module.exports = __webpack_public_path__ + "static/media/Abendessen-paid.64819677.png";